import styled from "styled-components";

import { ExternalLink } from "ui/Link";
import { FBPageExtended } from "api/social-account-connect/facebook";

import { GetConnectButtonState } from "../connect-button";
import { AccountList } from "../account-list";

interface FacebookPageListProps {
  className?: string;
  pages: FBPageExtended[];
  onConnect(acc: FBPageExtended): void;
  getConnectButtonState: GetConnectButtonState<FBPageExtended>;
}

export function FacebookPageList({
  className,
  pages,
  onConnect,
  getConnectButtonState,
}: FacebookPageListProps) {
  return (
    <Root className={className}>
      <h4>Select the Pages you'd like to add to Sked:</h4>
      <AccountList
        items={pages}
        getConnectButtonState={getConnectButtonState}
        renderItemLabel={(page) => (
          <>
            {page.name} (
            <ExternalLink href={`https://facebook.com/${page.id}`}>
              {page.id}
            </ExternalLink>
            )
          </>
        )}
        onConnect={onConnect}
      />
      <Caption>
        Missing a Page? Check our access in{" "}
        <ExternalLink href="https://www.facebook.com/settings?tab=business_tools">
          Business Integrations on Facebook
        </ExternalLink>
        . Click 'view and edit' to make sure you have given us permission for
        the Pages and/or Instagram Accounts.
      </Caption>
    </Root>
  );
}

const Caption = styled.p`
  font-size: 14px;
`;

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 8px;

  & > * {
    margin: 0;
  }
`;
